<template>
  <Table
    ref="table"
    :layers-filters="layersFilters"
    @setLayerFeaturesFilters="setLayerFeaturesFilters"
    @deleteLayerFeaturesFilters="deleteLayerFeaturesFilters"
  >
  </Table>
</template>
<script>
import { get, sync } from 'vuex-pathify';
import Table from '@/components/Table.vue';

export default {
  name: 'TableCutoffs',
  components: {
    Table,
  },
  computed: {
    activeTool: sync('tools/activeTool'),
    layersFilters: get('locks/cutoffLayersFiltered'),
    failuresLayerId: get('admin/modulesMapping@failures.layer_id'),
  },
  methods: {
    deleteLayerFeaturesFilters(currentLayerId) {
      this.$store.set('layers/DELETE_CUTOFF_LAYER_FEATURES_FILTERS!', currentLayerId);
    },
    onLayerChanged() {
      this.$refs.table.onLayerChanged();
    },
    setLayerFeaturesFilters(filter) {
      this.$store.set('locks/SET_CUTOFF_LAYER_FEATURES_FILTERS!', filter);
    },
  },
  beforeDestroy() {
    this.$nextTick(() => {
      this.activeTool = undefined;
    });
  },
};
</script>
